var map = {
	"./homepage.de-CH.json": 1397,
	"./homepage.de-DE.json": 1398,
	"./homepage.en-CA.json": 1399,
	"./homepage.en-GB.json": 1400,
	"./homepage.en-IN.json": 1401,
	"./homepage.en-ME.json": 1402,
	"./homepage.en-US.json": 1403,
	"./homepage.es-EM.json": 1404,
	"./homepage.es-ES.json": 1405,
	"./homepage.fr-BE.json": 1406,
	"./homepage.fr-CA.json": 1407,
	"./homepage.fr-CH.json": 1408,
	"./homepage.nl-BE.json": 1409,
	"./homepage.nl-NL.json": 1410,
	"./homepage.pl-PL.json": 1411,
	"./homepage.pt-BR.json": 1412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1396;